

export const SORT_ICON_STATE_COLOR = {
  ACTIVE: 'black',
  NOT_ACTIVE: 'black25',
  HOVERED: 'regent'
};